export enum TagType {
    GymService = 'GYMSERVICE',
    GymAdvantage = 'GYMADVANTAGE',
}
